import { useAtom } from 'jotai';
import { loadable } from 'jotai/utils';
import { projectsDataAtom, expressionsDataAtom, productInstancesDataAtom, selectedGenderAtom, filteredProjectsAtom, filteredExpressionsAtom, filteredProductInstancesAtom } from '~/atoms/productMatrix';
const projectsLoadingAtom = loadable(projectsDataAtom);
const expressionsLoadingAtom = loadable(expressionsDataAtom);
const productInstancesLoadingAtom = loadable(productInstancesDataAtom);
const filteredProjectsLoadingAtom = loadable(filteredProjectsAtom);
const filteredExpressionsLoadingAtom = loadable(filteredExpressionsAtom);
const filteredProductInstancesLoadingAtom = loadable(filteredProductInstancesAtom);
export function useProductMatrix() {
    const [projectsLoading] = useAtom(projectsLoadingAtom);
    const [expressionsLoading] = useAtom(expressionsLoadingAtom);
    const [productInstancesLoading] = useAtom(productInstancesLoadingAtom);
    const [filteredProjectsLoading] = useAtom(filteredProjectsLoadingAtom);
    const [filteredExpressionsLoading] = useAtom(filteredExpressionsLoadingAtom);
    const [filteredProductInstancesLoading] = useAtom(filteredProductInstancesLoadingAtom);
    const [selectedGender, setSelectedGender] = useAtom(selectedGenderAtom);
    const isLoading = projectsLoading.state === 'loading' ||
        expressionsLoading.state === 'loading' ||
        productInstancesLoading.state === 'loading';
    const hasError = projectsLoading.state === 'hasError' ||
        expressionsLoading.state === 'hasError' ||
        productInstancesLoading.state === 'hasError';
    const error = hasError
        ? projectsLoading.state === 'hasError'
            ? projectsLoading.error instanceof Error
                ? projectsLoading.error
                : new Error('Unknown error loading projects')
            : expressionsLoading.state === 'hasError'
                ? expressionsLoading.error instanceof Error
                    ? expressionsLoading.error
                    : new Error('Unknown error loading expressions')
                : productInstancesLoading.state === 'hasError'
                    ? productInstancesLoading.error instanceof Error
                        ? productInstancesLoading.error
                        : new Error('Unknown error loading product instances')
                    : null
        : null;
    const filteredProjects = filteredProjectsLoading.state === 'hasData'
        ? filteredProjectsLoading.data
        : [];
    const filteredExpressions = filteredExpressionsLoading.state === 'hasData'
        ? filteredExpressionsLoading.data
        : [];
    const filteredProductInstances = filteredProductInstancesLoading.state === 'hasData'
        ? filteredProductInstancesLoading.data
        : [];
    return {
        filteredProjects,
        filteredExpressions,
        filteredProductInstances,
        selectedGender,
        setSelectedGender,
        isLoading,
        error
    };
}
